import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Customers API
export const customersApi = {
  getAll: () => api.get('/customers'),
  getById: (id) => api.get(`/customers/${id}`),
  create: (data) => api.post('/customers', data),
  update: (id, data) => api.put(`/customers/${id}`, data),
  delete: (id) => api.delete(`/customers/${id}`),
  getStats: () => api.get('/customers/stats')
};

// Invoices API
export const invoicesApi = {
  getAll: (params) => api.get('/invoices', { params }),
  getById: (id) => api.get(`/invoices/${id}`),
  create: (data) => api.post('/invoices', data),
  send: (id) => api.put(`/invoices/${id}/send`),
  delete: (id) => api.delete(`/invoices/${id}`)
};

// Payments API
export const paymentsApi = {
  getAll: (params) => api.get('/payments', { params }),
  getById: (id) => api.get(`/payments/${id}`),
  create: (data) => api.post('/payments', data)
};

// Expenses API
export const expensesApi = {
  getAll: (params) => api.get('/expenses', { params }),
  getById: (id) => api.get(`/expenses/${id}`),
  create: (data) => api.post('/expenses', data),
  update: (id, data) => api.put(`/expenses/${id}`, data),
  delete: (id) => api.delete(`/expenses/${id}`),
  getCategories: () => api.get('/expenses/categories'),
  getSummary: () => api.get('/expenses/summary')
};

// Dashboard API
export const dashboardApi = {
  getStats: () => api.get('/dashboard/stats'),
  getSalesFunnel: () => api.get('/dashboard/sales-funnel'),
  getProfitLoss: (period) => api.get('/dashboard/profit-loss', { params: { period } }),
  getBankAccounts: () => api.get('/dashboard/bank-accounts')
};

// Reports API
export const reportsApi = {
  getAll: (type) => api.get('/reports', { params: { type } }),
  getFavorites: () => api.get('/reports/favorites'),
  toggleFavorite: (id) => api.put(`/reports/${id}/favorite`),
  generate: (reportName, params) => api.get(`/reports/generate/${reportName}`, { params })
};

// AI Assistant API
export const aiApi = {
  chat: (sessionId, message) => api.post('/ai/chat', { session_id: sessionId, message }),
  getChatHistory: (sessionId) => api.get(`/ai/chat/history/${sessionId}`),
  clearChatHistory: (sessionId) => api.delete(`/ai/chat/history/${sessionId}`),
  categorizeExpense: (description, amount) => 
    api.post('/ai/categorize-expense', null, { params: { description, amount } }),
  getInsights: () => api.get('/ai/insights')
};

// Seed database
export const seedDatabase = () => api.post('/seed');

export default api;
